import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Input } from 'antd';
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Controller } from 'react-hook-form';

import GetField from '../Components/GetField';
import styles from '../styles';

const AntInput = GetField(Input);

const TermForm = props => {
  const { classes, control, termItem, termIndex, termRemove, termAppend } =
    props;

  return (
    <tr>
      <td className={classes.inputTd}>
        <Controller
          name={`terms[${termIndex}].term`}
          control={control}
          defaultValue={termItem.term}
          render={({ field }) => (
            <AntInput placeholder="Term" size="small" {...field} />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <DeleteOutlined
          onClick={() => {
            termRemove(termIndex);
          }}
        />
        &nbsp; &nbsp;
        <PlusCircleOutlined onClick={() => termAppend({})} />
      </td>
    </tr>
  );
};

TermForm.propTypes = {
  classes: PropTypes.object.isRequired,
  control: PropTypes.any.isRequired,
  termAppend: PropTypes.func.isRequired,
  termRemove: PropTypes.func.isRequired,
  termItem: PropTypes.object.isRequired,
  termIndex: PropTypes.number.isRequired,
};

export default withStyles(styles)(TermForm);
